import React from 'react';

import classNames from 'classnames';

import CrossSymbol from '@travauxlib/shared/src/components/DesignSystem/assets/CrossSymbolFilled.svg?react';

import { TagSize, Variant } from './types';
import {
  avatarSizeMapper,
  makeIconContainerClassName,
  makeLeftMarginClassName,
  makeRightMarginClassName,
  makeTagContainerClassName,
  sizeForIconButton,
} from './utils';

import { Avatar } from '../Avatar';
import { IconButton } from '../Buttons/IconButton';

export type { Variant } from './types';

export type Props = {
  label?: string | React.ReactElement;
  variant: Variant;
  size?: TagSize;
  icon?: React.ReactElement;
  onClose?: () => void;
  onClick?: () => void;
  rightIcon?: React.ReactElement;
  className?: string;
  isRightIconActive?: boolean;
  isBorder?: boolean;
  avatarUrl?: string;
};

export const Tag: React.FC<Props> = ({
  variant,
  size = 'md',
  label,
  icon,
  rightIcon,
  onClose = undefined,
  className,
  onClick,
  isRightIconActive,
  isBorder,
  avatarUrl,
}) => {
  const iconButtonVariant =
    variant === 'light' ||
    variant === 'disabled' ||
    variant === 'secondary' ||
    variant === 'contextual'
      ? 'white'
      : variant;
  return (
    <span
      onClick={onClick}
      className={makeTagContainerClassName({
        variant,
        size,
        hasIcon: !!icon,
        hasClose: !!onClose,
        className,
        rightIcon: !!rightIcon,
        isBorder,
        hasLabel: !!label,
      })}
      role={onClick ? 'button' : 'contentinfo'}
      aria-label={typeof label === 'string' ? label : undefined}
    >
      {icon && (
        <span
          className={classNames(
            makeIconContainerClassName({ size }),
            makeRightMarginClassName({ size, hasLabel: !!label }),
          )}
        >
          {icon}
        </span>
      )}
      {avatarUrl && (
        <Avatar
          className={makeRightMarginClassName({ size, hasLabel: !!label })}
          pictureURL={avatarUrl}
          size={avatarSizeMapper[size]}
        />
      )}
      {label}
      {rightIcon && (
        <span
          className={classNames(
            makeIconContainerClassName({ size }),
            makeLeftMarginClassName({ size, hasLabel: !!label }),
          )}
        >
          <IconButton
            variant={iconButtonVariant}
            size={sizeForIconButton[size]}
            isActive={isRightIconActive}
            dataTestId="right-icon"
          >
            {rightIcon}
          </IconButton>
        </span>
      )}
      {onClose && (
        <span
          onClick={onClose}
          className={classNames(
            makeIconContainerClassName({ size }),
            makeLeftMarginClassName({ size, hasLabel: !!label }),
          )}
        >
          <IconButton variant={iconButtonVariant} size={sizeForIconButton[size]}>
            <CrossSymbol data-testid="close-icon" />
          </IconButton>
        </span>
      )}
    </span>
  );
};
